import React from "react";
import "../../../css/components/Layout.css";
import aboutImg from "../../../assets/images/Home3.jpg"; // Update with your actual image path

const AboutUs = () => (
  <section className="white-container">
    <div className="white-container-content">
      <div className="column">
        <h2 className="burgandy">About Us</h2>
        <div className="divider burgandy" />
        <div className="row">
          <img
            src={aboutImg}
            alt="WPP Financial Services Building"
            className="image-container"
          />

          <div className="content-column">
            <div className="content-semibold grey align-left">
              WPP Financial Services provides expert, straightforward mortgage
              and protection advice, helping individuals and families make
              confident, informed financial decisions. 
            </div>
            <div className="content grey align-left">
              We believe financial advice should be clear, transparent and
              tailored to you. That is why we take the time to understand your
              circumstances, goals and priorities before recommending solutions
              that genuinely suit your needs. Whether you are buying your first
              home, remortgaging or expanding your property portfolio, we are
              here to guide you every step of the way with honest, jargon-free
              support.
            </div>
            <div className="content grey align-left">
              As a trusted and regulated adviser, we are committed to
              maintaining the highest standards of professionalism and client
              care. Our approach is built on long-term relationships, not
              short-term transactions, ensuring you always have a reliable
              partner to turn to as your financial situation evolves.
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutUs;
